import { normalizeUiMessage } from './utils/message-normalizer';
import { Component } from '@angular/core';

import { Platform, AlertController, ToastController, MenuController, NavController, IonRouterOutlet } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { LoadingController } from '@ionic/angular';
import { Router, ActivatedRoute, RouterModule, NavigationEnd } from '@angular/router';
import { LocationService } from './services/location.service';
import { Location } from '@angular/common';
import { ViewChild } from '@angular/core';
import { appServerResources } from './app server constants';
import { Device } from "@ionic-native/device/ngx";
import { MenuService } from './services/menu.service';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})

export class AppComponent {
  mySubscription;

  isUserLoggedIn: any;
  isSupportClicked: boolean = false;
  exports: [RouterModule];
  selectedBusiness: any;
  userName: any;
  shouldShowOrderStatuses: boolean = false;
  supportPhoneNumber;
  citiesArray: any[] = [];
  businessArray: any[] = [];
  citiesArrayCopy: any[] = [];
  areaArray :any[] = [];
  loading: any;
  logoImageUrl: any;
  socialText: any;
  appbackgroundColor: any;
  isAreaLoaded :boolean = false;
  isOnline = true;

  filteredCategories: any[] = [];
  allCategories: any[] = [];

  private resolveInitialRoute(pathname: string): string {
    const rawPath = (pathname || '').trim();
    if (!rawPath || rawPath === '/') {
      return 'location';
    }

    let normalized = rawPath.replace(/^\/+|\/+$/g, '');

    // Handle deployed app base folder names like /mintui or /mintUi
    if (normalized.toLowerCase() === 'mintui') {
      return 'location';
    }
    if (normalized.toLowerCase().startsWith('mintui/')) {
      normalized = normalized.substring(normalized.indexOf('/') + 1);
    }

    // Handle legacy hosted prefixes
    normalized = normalized.replace(/^pune-eats\/m\//i, '').replace(/^m\//i, '');

    if (!normalized || normalized.toLowerCase() === 'home') {
      return 'location';
    }

    return normalized;
  }

  private decodeUrlValue(value?: string | null): string {
    if (!value) {
      return '';
    }
    try {
      return decodeURIComponent(value);
    } catch {
      return value;
    }
  }

  private normalizePropertyName(rawPropertyName?: string | null): string {
    const decodedPropertyName = this.decodeUrlValue(rawPropertyName).trim();
    if (!decodedPropertyName) {
      return '';
    }

    // Handle malformed nested query strings, e.g. "location?propertyName=home".
    const nestedQueryIndex = decodedPropertyName.indexOf('?');
    if (nestedQueryIndex !== -1) {
      const nestedPath = decodedPropertyName.substring(0, nestedQueryIndex).trim();
      const nestedQuery = decodedPropertyName.substring(nestedQueryIndex + 1);
      const nestedParams = new URLSearchParams(nestedQuery);
      const nestedPropertyName = this.decodeUrlValue(nestedParams.get('propertyName')).trim();
      if (nestedPropertyName) {
        if (nestedPropertyName.toLowerCase() === 'home') {
          return '';
        }
        return nestedPropertyName;
      }
      return nestedPath;
    }

    if (decodedPropertyName.toLowerCase() === 'home') {
      return '';
    }

    return decodedPropertyName;
  }

  constructor(private navController: NavController, private route: ActivatedRoute,
    private platform: Platform, location: Location,
    private splashScreen: SplashScreen, private menu: MenuController,
    private statusBar: StatusBar, private router: Router, private alertController: AlertController,
    private toastController: ToastController, private locationService: LocationService, 
    private device: Device, 
    public loadingController: LoadingController,private menuService: MenuService
  ) {
const bareRootRedirects: { [hostname: string]: string } = {
      'orders.mintbistro.com': 'https://www.mintbistro.com/',
      'order.mintbistro.com': 'https://www.mintbistro.com/',
      'order.divinedosa.com': 'https://www.divinedosa.com/',
      'orders.divinedosa.com': 'https://www.divinedosa.com/'
    };
    const isBareRootPath =
      (window.location.pathname === '/' || window.location.pathname === '') &&
      !window.location.search;
    const bareRootTarget = bareRootRedirects[window.location.hostname];
    if (isBareRootPath && bareRootTarget) {
      window.location.href = bareRootTarget;
      return;
    }

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.mySubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
      }
    });

    this.menuService.categories$.subscribe(categories => {
      this.allCategories = categories;
      this.filteredCategories = categories;
    });

    this.initializeApp();
  }

  filterCategories(event: any) {

    const searchTerm = event.target.value.toLowerCase() || '' ;

    if (!searchTerm) {
      this.filteredCategories = Array.from(this.allCategories);
      return;
    }

    this.filteredCategories = this.allCategories.filter(category =>
      category.displayName.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }

  selectCategory(category: any) {
    this.menuService.selectCategory(category);
    this.menuService.closeMenu();
  }

  closeMenu1(){
    this.menuService.closeMenu();
  }

  ionSplitPaneVisible() {
    console.log("ionSplitPaneVisible");
  }

  getValue() {

    if (this.router.url == '/location') {
      this.shouldShowOrderStatuses = false;
    }

    let loggedInUser = JSON.parse(localStorage.getItem('loggedInUser'));

    if (loggedInUser && this.isUserLoggedIn) {

      if (loggedInUser.nirvanaXpUser) {
        if (loggedInUser.nirvanaXpUser.firstName && loggedInUser.nirvanaXpUser.lastName) {
          return loggedInUser.nirvanaXpUser.firstName + " " + loggedInUser.nirvanaXpUser.lastName;
        } else if (loggedInUser.nirvanaXpUser.firstName) {
          return loggedInUser.nirvanaXpUser.firstName;
        } else if (loggedInUser.nirvanaXpUser.lastName) {
          return loggedInUser.nirvanaXpUser.lastName;
        }

      } else {
        if (loggedInUser.firstName && loggedInUser.lastName) {
          return loggedInUser.firstName + " " + loggedInUser.lastName;
        } else if (loggedInUser.firstName) {
          return loggedInUser.firstName;
        } else if (loggedInUser.lastName) {
          return loggedInUser.lastName;
        }
      }


    } else {
      return "";
    }
  }

  initializeApp() {

    this.platform.ready().then(() => {
      this.isOnline = navigator.onLine;
      window.addEventListener('online', () => this.isOnline = true);
      window.addEventListener('offline', () => this.isOnline = false);

      document.addEventListener('backbutton', () => {
        console.log('Hardware back button disabled on the device');
        return false;
      });

      // window.location.href ='https://orders.mintbistro.com/m/reservationschedule'
      const parsedUrl = new URL(window.location.href);

      const protocol = parsedUrl.protocol;
      const hostname = parsedUrl.hostname;
      const port = parsedUrl.port;
      const pathname = parsedUrl.pathname;
      const search = parsedUrl.search;
      const hash = parsedUrl.hash;

      console.log('Protocol:', protocol);
      console.log('Hostname:', hostname);
      console.log('Port:', port);
      console.log('Pathname:', pathname);
      console.log('Search:', search);
      console.log('Hash:', hash);

if (hostname == "orders.mintbistro.com" || hostname == "order.divinedosa.com")
        appServerResources.shouldDisableBackButton = 1;
      else
        appServerResources.shouldDisableBackButton = 0;

      // Apply hostname-based theme immediately, before API response, to avoid stale localStorage color
      if (hostname === 'order.divinedosa.com') {
        document.documentElement.style.setProperty('--ion-color-green', '#4A0000');
        document.documentElement.style.setProperty('--ion-border-radius', '0 0 0 0');
        localStorage.setItem('themeColor', '#4A0000');
      } else if (hostname === 'orders.mintbistro.com') {
        document.documentElement.style.setProperty('--ion-color-green', '#2E7D32');
        document.documentElement.style.setProperty('--ion-border-radius', '15px 0 15px 0');
        localStorage.setItem('themeColor', '#2E7D32');
      } else {
        // Dev / localhost: use stored theme or default green
        let themeColor = localStorage.getItem('themeColor');
        if (themeColor != null) {
          document.documentElement.style.setProperty('--ion-color-green', themeColor);
        } else {
          document.documentElement.style.setProperty('--ion-color-green', '#2E7D32');
        }
        document.documentElement.style.setProperty('--ion-border-radius', '15px 0 15px 0');
      }

      console.log("shlok returnToOrderPagePopup ---------------------------- ", JSON.parse(localStorage.getItem("returnToOrderPagePopup")));

      const params = new URLSearchParams(window.location.search);
      const vars: any = {};
      params.forEach((value, key) => {
        vars[key] = value;
      });
vars['propertyName'] = this.normalizePropertyName(vars['propertyName']);
      vars['locationId'] = this.decodeUrlValue(vars['locationId']);

      // Web middleware appends the identifier as a path segment (e.g. /82),
      // not a query param. Pick it up here so it goes through the same
      // getUrlParam lookup + redirect logic as the query-param flow.
      if (!vars['propertyName']) {
        const pathSegment = pathname.replace(/^\/+|\/+$/g, '').split('/')[0];
        const reservedRoutes = ['location', 'home', 'm', 'mintui', 'order', 'checkout', 'login',
          'loginasguest', 'reservationschedule', 'reservationlist', 'order-history',
          'order-status-track', 'order-detail', 'arrtibute-selection', ''];
        if (pathSegment && !reservedRoutes.includes(pathSegment.toLowerCase())) {
          vars['propertyName'] = pathSegment;
        }
      }

      console.log("window.location.href " + window.location.href);
      console.log("vars['propertyName']1 " + vars['propertyName']);
      console.log("vars[locationId]" + vars['locationId']);
      console.log("we are in app.componenets.ts and locationId is" + vars['locationId'])


      // if(location.pathname != "/checkout"){
      // localStorage.setItem("cartArray", null);
      // localStorage.setItem("selectedOrderSourceGroup", null);
      // localStorage.setItem("selectedOrderSourceGroupObject", null);
      // localStorage.setItem("scheduleNowLater", null);
      // localStorage.setItem("propertyName", "");

      localStorage.setItem('isTableOrderClosed', "1")
      // localStorage.setItem("cartArray", null);
      // localStorage.setItem("selectedOrderSourceGroup", null);
      // localStorage.setItem("selectedOrderSourceGroupObject", null);
      // localStorage.setItem("scheduleNowLater", null);
      // localStorage.setItem("propertyName", "");

      // localStorage.setItem("paramlocationId", "");

      // vars['propertyName'] = 'reservationschedule'
      // vars['locationId']= undefined
      // vars['locationId']= null



      if (vars['propertyName'] != 'm' && vars['propertyName'] != undefined && vars['propertyName'] != '') {
        //   if(vars['propertyName'] == 'order'){
        //     this.navController.navigateForward('order');
        //   }
        //   if(vars['propertyName'] == 'loginasguest'){
        //     this.navController.navigateForward('loginasguest');
        //   }
        //   if(vars['propertyName'] == 'login'){
        //     this.navController.navigateForward('login');
        //   }
        //    if(vars['propertyName'] == 'reservationschedule'){
        //     this.navController.navigateForward('reservationschedule');
        //   }
        //   if(vars['propertyName'] == 'reservationlist'){
        //     this.navController.navigateForward('reservationlist');
        //   }
        //   if(vars['propertyName'] == 'arrtibute-selection'){
        //     this.navController.navigateForward('arrtibute-selection');
        //   }
        //  if(vars['propertyName'] == 'order-detail'){
        //     this.navController.navigateForward('order-detail');
        //   }
        //   if(vars['propertyName'] == 'checkout'){
        //     this.navController.navigateForward('checkout');
        //   }
        //   if(vars['propertyName'] == 'order-history'){
        //     this.navController.navigateForward('order-history');
        //   }
        //   if(vars['propertyName'] == 'order-status-track'){
        //     this.navController.navigateForward('order-status-track');
        //   }

      


        localStorage.setItem("auth-token", '8fc8e05d-873d-4ea5-9db4-d2442ce8983f');
        localStorage.setItem("userSelectedReservation", null);
        this.locationService.getUrlParam(vars['propertyName']).subscribe((response: any) => {
          console.log("get url param responce", response);
          console.log("vars['propertyName']", vars['propertyName']);
          if (response.businessId != "undifined" && response.businessId != '' && response.businessId > 0) {


            localStorage.setItem("propertyName", vars['propertyName']);
            console.log("hiiiiiiiii");
            localStorage.setItem("selectedOptionsFromHome", '')
            localStorage.setItem('isTableOrderClosed', "1")
            localStorage.setItem("paramBusinessId", response.businessId);
            localStorage.setItem("paramPropertyId", response.propertyId);
            localStorage.setItem("paramCityId", response.cityId);

            if (response.pickupDelivery == 1) {
              localStorage.setItem("selectedOptionsFromHome", 'Contactless Pickup & Delivery')
              this.locationService.getBusiness(parseInt(response.businessId))
                .subscribe((res: any) => {
                  console.log("here we go==========", res);
                  localStorage.setItem("auth-token", res[0].authToken);
                  localStorage.setItem("selectedBusiness", JSON.stringify(res[0]))
                  this.applyThemeToToolbar();
                  localStorage.setItem("auth-token", res[0].authToken);
                  localStorage.setItem("local-auth-token", res[0].authToken);
                  localStorage.setItem("cartArray", null);
                  localStorage.setItem("selectedOptionsFromHome", 'Contactless Pickup & Delivery');
                  localStorage.setItem("SelectedCity", null);

                  let primaryColor: any = '#2E7D32';
                  if (res[0].locationId == 940) {
                    primaryColor = '#4A0000';
                    document.documentElement.style.setProperty('--ion-border-radius', '0 0 0 0');
                  }

                  document.documentElement.style.setProperty('--ion-color-green', primaryColor);

                  if(appServerResources.propertyId == 2){
                     primaryColor = '#4A0000';
                    document.documentElement.style.setProperty('--ion-color-green', primaryColor);

                  }

                  localStorage.setItem('themeColor', primaryColor);
                  localStorage.setItem('isFromReservationLink', "0")

                  this.navController.navigateRoot('order');
                });

            } else if (response.tableContactlessMenu == 1 && vars['locationId'] != 'undefined') {
              console.log("hiiiiiiiii3");
              localStorage.setItem('isTableOrderClosed', "1")
              localStorage.setItem("selectedOptionsFromHome", 'Contactless Table Order')
              localStorage.setItem("paramlocationId", vars['locationId']);
              localStorage.setItem("partySizeSelected", '0');
              this.locationService.getBusiness(parseInt(response.businessId))
                .subscribe((res: any) => {
                  console.log("here we go==========", res);
                  localStorage.setItem("auth-token", res[0].authToken);
                  localStorage.setItem("selectedBusiness", JSON.stringify(res[0]))
                  localStorage.setItem("auth-token", res[0].authToken);
                  localStorage.setItem("local-auth-token", res[0].authToken);
                  console.log("hiiiiiiiii3.0", vars['locationId']);
                  let primaryColor: any = '#2E7D32';
                  if (res[0].locationId == 940) {
                    primaryColor = '#4A0000';
                    document.documentElement.style.setProperty('--ion-border-radius', '0 0 0 0');
                  }


                  document.documentElement.style.setProperty('--ion-color-green', primaryColor);

                  if(appServerResources.propertyId == 2){
                     primaryColor = '#4A0000';
                    document.documentElement.style.setProperty('--ion-color-green', primaryColor);

                  }
                  localStorage.setItem('isFromReservationLink', "0")

                  localStorage.setItem('themeColor', primaryColor);
                  this.navController.navigateRoot('order');
                });

            }

            else if (response.waitlist == 1 && vars['locationId'] != 'undefined') {
              localStorage.setItem("selectedOptionsFromHome", 'Waitlist');
              this.locationService.getBusiness(parseInt(response.businessId))
                .subscribe((res: any) => {
                  console.log("here we go==========", res);
                  localStorage.setItem("auth-token", res[0].authToken);
                  localStorage.setItem("selectedBusiness", JSON.stringify(res[0]))
                  let primaryColor: any = '#2E7D32';
                  if (res[0].locationId == 940) {
                    primaryColor = '#4A0000';
                    document.documentElement.style.setProperty('--ion-border-radius', '0 0 0 0');
                  }


                  document.documentElement.style.setProperty('--ion-color-green', primaryColor);

                  if(appServerResources.propertyId == 2){
                     primaryColor = '#4A0000';
                    document.documentElement.style.setProperty('--ion-color-green', primaryColor);

                  }
                  localStorage.setItem('isFromReservationLink', "0")

                  localStorage.setItem('themeColor', primaryColor);
                  if (JSON.parse(localStorage.getItem("loggedInUser"))) {
                    this.router.navigateByUrl('/resercationinformation');
                  } else {
                    localStorage.setItem("isUserNavigatedFromCheckout", "resercationinformation");
                    this.router.navigateByUrl('/loginasguest');
                  }
                },
                  (err) => {
                    console.log(err);
                  });
            }

            else if (response.menu == 1) {
              console.log("hiiiiiiiii2");
              localStorage.setItem("selectedOptionsFromHome", 'Contactless Menu')
              this.locationService.getBusiness(parseInt(response.businessId))
                .subscribe((res: any) => {
                  console.log("here we go==========", res);
                  localStorage.setItem("auth-token", res[0].authToken);
                  localStorage.setItem("selectedBusiness", JSON.stringify(res[0]))
                  localStorage.setItem("auth-token", res[0].authToken);
                  localStorage.setItem("local-auth-token", res[0].authToken);
                  let primaryColor: any = '#2E7D32';
                  if (res[0].locationId == 940) {
                    primaryColor = '#4A0000';
                    document.documentElement.style.setProperty('--ion-border-radius', '0 0 0 0');
                  }

                  document.documentElement.style.setProperty('--ion-color-green', primaryColor);
                  if(appServerResources.propertyId == 2){
                     primaryColor = '#4A0000';
                    document.documentElement.style.setProperty('--ion-color-green', primaryColor);

                  }    
                    localStorage.setItem('isFromReservationLink', "0")


                  localStorage.setItem('themeColor', primaryColor);
                  this.navController.navigateForward('order');

                });
            } else {
              localStorage.setItem("selectedOptionsFromHome", 'Reserve & Pre-Select');
              localStorage.setItem('isFromReservationLink', "1")

              this.locationService.getBusiness(parseInt(response.businessId))
                .subscribe((res: any) => {
                  console.log("here we go==========", res);
                  localStorage.setItem("auth-token", res[0].authToken);
                  localStorage.setItem("selectedBusiness", JSON.stringify(res[0]))
                  localStorage.setItem("local-auth-token", res[0].authToken);
                  let primaryColor: any = '#2E7D32';
                  if (res[0].locationId == 940) {
                    primaryColor = '#4A0000';
                    document.documentElement.style.setProperty('--ion-border-radius', '0 0 0 0');
                  }

                  document.documentElement.style.setProperty('--ion-color-green', primaryColor);

                  if(appServerResources.propertyId == 2){
                     primaryColor = '#4A0000';
                    document.documentElement.style.setProperty('--ion-color-green', primaryColor);
                  }

                  localStorage.setItem('themeColor', primaryColor);

                  if (JSON.parse(localStorage.getItem("loggedInUser"))) {
                    this.navController.navigateRoot('reservationschedule');
                  } else {
                    localStorage.setItem("isUserNavigatedFromCheckout", "reservationschedule");
                    this.navController.navigateRoot('loginasguest');
                  }
                },
                  (err) => {
                    console.log(err);
                  });
            }
          } else if (response.propertyId != "undifined" && response.propertyId != '' && response.propertyId > 0
            && response.cityId != "undifined" && response.cityId != '' && response.cityId > 0) {
              localStorage.setItem('isFromReservationLink', "0")

            localStorage.setItem("propertyName", "");
            if (vars['locationId'] != 'undefined') {
              localStorage.setItem("paramlocationId", vars['locationId']);
            }

            localStorage.setItem("paramPropertyId", response.propertyId);
            localStorage.setItem("paramCityId", response.cityId);
            this.navController.navigateRoot('location');
          } else if (response.propertyId != "undifined" && response.propertyId != '' && response.propertyId > 0) {
            console.log("shlok dev");
            localStorage.setItem("propertyName", "");
            localStorage.setItem("paramPropertyId", response.propertyId);
            this.navController.navigateRoot('location');//here
          } else {
            localStorage.setItem("propertyName", "");
            if (hostname == "orders.mintbistro.com" || hostname == "order.divinedosa.com"){
              let previousAuthToken = localStorage.getItem('local-auth-token');
              if(previousAuthToken != null && previousAuthToken != '' && previousAuthToken != 'null') 
              localStorage.setItem('auth-token',previousAuthToken);

              let navUrl = '/' + vars['propertyName'];
              this.router.navigateByUrl(navUrl);
            }


          }
        });
       } else if (vars['propertyName'] == 'm' && vars['locationId']) {
        // if(vars['locationId']=='order'){
        //   this.navController.navigateRoot(vars['locationId']);
        // }
        localStorage.setItem('isFromReservationLink', "0")

        if (vars['locationId'] == 'home') {
          localStorage.setItem("selectedOptionsFromHome", '')
          this.navController.navigateRoot('location');
        }
        else {
          this.navController.navigateRoot(vars['locationId']);
        }

      } else {
        localStorage.setItem('isFromReservationLink', "0")

        //localStorage.setItem("selectedOptionsFromHome", '')
        console.log("shlok path -------------------- " + location.pathname)
        localStorage.setItem("propertyName", "");
        localStorage.removeItem("paramBusinessId");
        localStorage.removeItem("paramPropertyId");
        localStorage.removeItem("paramCityId");

        const route = this.resolveInitialRoute(location.pathname);

        console.log(route);
        this.navController.navigateRoot(route + search);
      }
      this.homepageData();
      this.statusBar.styleDefault();
      setTimeout(() => {
        this.splashScreen.hide();
      }, 1000);
    });
  }

 async homepageData() {
    this.isUserLoggedIn = JSON.parse(localStorage.getItem("loggedInUser"));
    
    var propertyId = JSON.parse(localStorage.getItem("paramPropertyId"));
    if (propertyId == null) {
      propertyId = appServerResources.propertyId;
    }

    localStorage.setItem("propertyId", propertyId + "");
    await this.getAllOnlineCity();
    await this.getAllCountries();
    await this.getPropertyById();

    if (this.device.uuid != null) {
      var deviceId = this.device.uuid;
      var deviceName = this.device.model;
    } else {
      var deviceId = "windows" + Math.floor(Math.random() * 100000);
      var deviceName = "nirvana-admin";
    }
    localStorage.setItem("deviceId", deviceId);
  }

  async getPropertyById() {
    // await this.presentLoading();

    this.locationService
      .getPropertyById(appServerResources.propertyId)
      .subscribe(
        (res: any) => {
          console.log(res);

          localStorage.setItem("HomeProperty", JSON.stringify(res));
          this.logoImageUrl = res.appLogo;
          this.socialText = res.subTitle;
          this.appbackgroundColor = res.background;
          // this.loading.dismiss();
        },
        (err) => {
          console.log(err);
          // this.loading.dismiss();
        }
      );
  }

  async getAllOnlineCity() {
    if (!JSON.parse(localStorage.getItem("citiesArray"))) {
      await this.presentLoading("Loading cities...");
    }

    this.locationService
      .getAllOnlineCity(appServerResources.propertyId)
      .subscribe(
        (res: any) => {
          console.log(res);

          this.citiesArray = [];
          this.citiesArrayCopy = [];

          this.citiesArrayCopy = res;
          for (let index = 0; index < res.length; index++, index++) {
            const element1 = res[index];
            const element2 = res[index + 1];

            let tempArray = [];
            tempArray.push(element1);
            if (element2) {
              tempArray.push(element2);
            }

            this.citiesArray.push(tempArray);
          }
          // this.citiesArray = res;

          // localStorage.setItem("citiesArray", JSON.stringify(this.citiesArray));
          // localStorage.setItem(
          //   "citiesArrayCopy",
          //   JSON.stringify(this.citiesArrayCopy)
          // );
          if (this.loading) {
            this.loading.dismiss();
          }
          if(this.citiesArrayCopy.length == 1){
            localStorage.setItem("SelectedCity", JSON.stringify(this.citiesArrayCopy[0]));
            this.getAreaByCityId(this.citiesArrayCopy);
          }
          else{
            localStorage.setItem("SelectedCity", JSON.stringify(this.citiesArrayCopy[0]));
            this.getAreaByCityId(this.citiesArrayCopy);

          }

        },
        (err) => {
          console.log(err);
          this.loading.dismiss();
        }
      );
  }

  getAreaByCityId(cityArray){
    this.locationService
      .getAreaByCityId(cityArray[0].id)
      .subscribe(
        (res: any) => {
          console.log(res);
          res = res.filter(item => { return item.status == 'A' || item.status == 'F'});

          
          this.areaArray =[];
          this.citiesArray = [];
          this.citiesArrayCopy = [];

          this.citiesArrayCopy = res;
          for (let index = 0; index < res.length; index++, index++) {
            const element1 = res[index];
            const element2 = res[index + 1];

            let tempArray = [];
            tempArray.push(element1);
            if (element2) {
              tempArray.push(element2);
            }

            this.areaArray.push(tempArray);
          }
          // this.citiesArray = res;

          localStorage.setItem("citiesArray", JSON.stringify(this.citiesArray));
          localStorage.setItem(
            "citiesArrayCopy",
            JSON.stringify(this.citiesArrayCopy)
          );
          localStorage.setItem("areaArray", JSON.stringify(this.areaArray));

          if (this.loading) {
            this.loading.dismiss();
          }
          this.isAreaLoaded = true;
        },
        (err) => {
          console.log(err);
          this.loading.dismiss();
        }
      );
  }

  async getAllCountries() {
    this.locationService.getAllCountries().subscribe(
      (res: any) => {
        console.log(res);

        localStorage.setItem("countryArray", JSON.stringify(res));

        // this.loading.dismiss();
      },
      (err) => {
        console.log(err);
        // this.loading.dismiss();
      }
    );
  }

  async presentLoading(msg) {
    this.loading = await this.loadingController.create({
      message: normalizeUiMessage(msg),
    });
    // Present the loading controller
    await this.loading.present();
  }

  login() {
    let str = this.router.url.replace(/\//g, '')
    console.log('url is===', str)
    localStorage.setItem("isUserNavigatedFromCheckout", str);
    this.router.navigateByUrl('/loginasguest');
    this.menu.close('order-menu');
  }

  async presentTwoBtnAlertLogout() {
    const alert = await this.alertController.create({
      header: '',
      backdropDismiss: false,
      message: "Are you sure you want to logout?",
      cssClass: 'custom-alert-class',
      buttons: [
        {
          text: 'No',
          cssClass: 'alert-button-no',
          handler: () => {
            console.log('Favorite clicked');
          }
        }, {
          text: 'Yes',
          cssClass: 'alert-button-yes',
          role: 'Yes',
          handler: () => {

            this.isUserLoggedIn = false;
            localStorage.setItem('isUserLoggedIn', null);
            localStorage.setItem('loggedInUser', null);
            localStorage.setItem("localUser", null);
            localStorage.removeItem("postLoginReservationTab");
            localStorage.removeItem("userSelectedReservation");
            localStorage.removeItem("selectedSlot");
            localStorage.removeItem("partySizeSelected");
            localStorage.removeItem("selectedPointOfServiceCount");
            let str = this.router.url.replace(/\//g, '')
            console.log('url1 is===', str)
            localStorage.setItem("isUserNavigatedFromCheckout", str);

            this.presentToast("Logout Successfully");
            this.menu.close('order-menu');
            this.router.navigateByUrl('/loginasguest', { replaceUrl: true });

          }
        }
      ]
    });

    await alert.present();
  }


  async presentToast(msg) {
    const toast = await this.toastController.create({
      message: normalizeUiMessage(msg),
      duration: 2000,
      position: 'middle',
      cssClass: "toast-mess"

    });
    toast.present();
  }

  getOrders() {
    console.log('yaayy it works')
    this.isUserLoggedIn = JSON.parse(localStorage.getItem('loggedInUser'));

    let selectedBusiness = JSON.parse(localStorage.getItem('selectedBusiness'));
    if (selectedBusiness) {
      this.selectedBusiness = true;
    } else {
      this.selectedBusiness = false;
    }

  }
  async openSupport() {
    if (this.isSupportClicked == false) {
      this.isSupportClicked = true;

    } else {
      this.isSupportClicked = false;

    }
    console.log('we are in support')


  }

  private getSupportPhoneNumber(): string {
    const selectedBusiness = JSON.parse(localStorage.getItem('selectedBusiness') || 'null');
    const rawPhone = this.supportPhoneNumber || selectedBusiness?.phone || '';
    return String(rawPhone || '').trim();
  }

  private getSupportPhoneDigits(): string {
    return this.getSupportPhoneNumber().replace(/[^\d]/g, '');
  }

  private openExternalLink(link: string) {
    const isWebDesktop = this.platform.is('desktop') || this.platform.is('mobileweb');
    window.open(link, isWebDesktop ? '_blank' : '_system');
  }

  openWhatsAppSupport() {
    const phoneDigits = this.getSupportPhoneDigits();
    if (!phoneDigits) {
      this.presentToast('Support contact is currently unavailable.');
      return;
    }

    const isWebDesktop = this.platform.is('desktop') || this.platform.is('mobileweb');
    const waLink = isWebDesktop
      ? `https://wa.me/${phoneDigits}`
      : `whatsapp://send?phone=${phoneDigits}`;
    this.openExternalLink(waLink);
  }

  openEmailSupport() {
    this.openExternalLink('mailto:pr@mintbistro.com?subject=I%20have%20a%20query');
  }

  openPhoneSupport() {
    const phone = this.getSupportPhoneNumber();
    if (!phone) {
      this.presentToast('Support contact is currently unavailable.');
      return;
    }

    this.openExternalLink(`tel:${phone}`);
  }


redirectTo(link) {

  if (link == '/order-history' || link == '/order-status-track') {
    console.log(this.router.url);
    if (this.router.url == '/location') {
      this.presentToast("Please select location first.");
      return
    }
    localStorage.setItem('navigatedFrom', this.router.url);
    let location = JSON.parse(localStorage.getItem('locationInfo'));
    if (!location) {
      this.presentToast("Please select location first.");
      return
    }
  }

  // NEW: Set source when navigating to reservationschedule from sidebar
  if (link === '/reservationschedule' || link === '/reservationlist') {
    const currentUrl = this.router.url;
    let source = 'sidebar';
    
    if (currentUrl.includes('/order-history')) {
      source = 'order-history';
    } else if (currentUrl.includes('/myaccount')) {
      source = 'myaccount';
    } else if (currentUrl.includes('/order')) {
      source = 'order';
    } else if (currentUrl.includes('/reservationschedule')) {
      source = null;
    }
    
    if (source) {
      localStorage.setItem('reservationSourcePage', source);
    }
  }

  this.router.navigateByUrl(link);
  this.menu.close('order-menu');
}

  closeMenu() {
    this.menu.close('order-menu');
  }
  get isLocation940(): boolean {
  return JSON.parse(localStorage.getItem('selectedBusiness'))?.locationId === 940;
  }
  // 🔹 Helper: Get theme color based on location ID
getThemeColor(): string {
  // 1️⃣ Always force default green on the location selection page
  if (this.router.url.startsWith('/location')) {
    return '#2E7D32';
  }

  // 2️⃣ For all other pages, check the selected business
  const business = JSON.parse(localStorage.getItem('selectedBusiness') || 'null');
  return business?.locationId === 940 ? '#4A0000' : '#2E7D32';
}
applyThemeToToolbar(): void {
  const color = this.getThemeColor();
  document.documentElement.style.setProperty('--ion-toolbar-background', color);
  // Also update the legacy variable Ionic might use:
  document.documentElement.style.setProperty('--ion-color-green', color);
}

  ngOnDestroy() {
    if (this.mySubscription) {
      this.mySubscription.unsubscribe();
    }
  }



}
